/* ============================================================
   SAUNA TRAVEL — reservation booking (Direction A + Options)
   4ステップ: プラン+人数 → 週間グリッド → オプション → 確認 → 一括カートイン
   - 空き枠は reservation-availability.js（既存API・未改修）を利用
   - プラン=商品バリアント(時間×人数)、オプション=コレクション商品(option.*メタ)
   - セット商品: 親(プラン)+子(オプション)を _bundle_id で束ね /cart/add.js に一括投入
   依存: Vue3(global), window.ReservationAvailability
   ============================================================ */
;(function () {
  'use strict'

  // フロー別ステップ列（宣言的ステップモデル）。位置(1始まり step)に対応する
  // 画面キーを定義する。plan_first は従来の STEP1..4 と 1:1（回帰防止の要）。
  // 両フローとも position 3=options / 4=confirm は不変で、入れ替わるのは 1↔2 のみ。
  var FLOWS = {
    plan_first: ['plan', 'calendar', 'options', 'confirm'],
    calendar_first: ['calendar', 'plan', 'options', 'confirm'],
  }
  function normalizeFlowOrder(v) {
    // 許可外/空は plan_first にフォールバック（snippet 側でも正規化済みだが二重防御）。
    return v === 'calendar_first' ? 'calendar_first' : 'plan_first'
  }

  function boot() {
    var mount = document.getElementById('reservation-booking')
    if (!mount || !window.Vue) return
    if (mount.dataset.rsvMounted) return // 二重マウント防止(セクションとブロック併用時など)
    mount.dataset.rsvMounted = '1'

    var raw = document.getElementById('reservation-bootstrap')
    var BOOT = {}
    try {
      BOOT = JSON.parse(raw.textContent)
    } catch (e) {
      console.error('reservation bootstrap parse error', e)
      return
    }

    var U = window.ReservationAvailability.util
    var WD = ['日', '月', '火', '水', '木', '金', '土']

    // ---- pricing category axis (日別料金) --------------------
    // 料金カテゴリーは日付で決まる軸なのでユーザーには選ばせない。算出を detectDims の
    // 呼び出しより後ろに置くと var の巻き上げで undefined になり、除外が無言で効かない。
    var PRICING_OPTION_NAME = '料金カテゴリー' // variant-picker.liquid / API と同じ完全一致
    var optNames = (BOOT.plan && BOOT.plan.optionNames) || []
    var pricingIdx = optNames.indexOf(PRICING_OPTION_NAME) // -1 = 料金カテゴリー軸なし
    var hasPricingAxis = pricingIdx >= 0

    // ---- plan dimension detection (store-agnostic) ----------
    // バリアントの options から「人数軸」を推定する（excludeIdx は候補から外す）。
    function detectDims(plan, excludeIdx) {
      if (!plan || !plan.variants || !plan.variants.length) {
        return { peopleIdx: null }
      }
      var nOpt = plan.variants[0].options ? plan.variants[0].options.length : 0
      if (nOpt <= 1) return { peopleIdx: null }
      // 各 option 軸が数値（人数）かどうかを判定
      var numericScore = []
      for (var i = 0; i < nOpt; i++) numericScore[i] = 0
      // 人数軸 = 値が「2」「2名」「2人」のように "数字(+名/人)" で完結するもの。
      // 「90分：通常プラン」等は数字始まりでも人数ではないので全体一致で判定する。
      plan.variants.forEach(function (v) {
        ;(v.options || []).forEach(function (val, i) {
          if (i === excludeIdx) return
          var s = String(val).trim()
          if (/^\d{1,3}\s*(名|人|名様|人様)?$/.test(s)) numericScore[i]++
        })
      })
      var peopleIdx = null,
        best = 0
      for (var j = 0; j < nOpt; j++) {
        if (numericScore[j] > best) {
          best = numericScore[j]
          peopleIdx = j
        }
      }
      return { peopleIdx: peopleIdx }
    }

    function distinct(arr) {
      var seen = {},
        out = []
      arr.forEach(function (x) {
        var k = String(x)
        if (!seen[k]) {
          seen[k] = 1
          out.push(x)
        }
      })
      return out
    }

    // 軸の解析: 人数軸(数値) + その他すべての option 軸に対応。
    // primaryIdx = 最初の非人数軸(=プラン)。extraIdxs = それ以外の非人数軸(その他)。
    var dims = detectDims(BOOT.plan, pricingIdx)
    var peopleIdx = dims.peopleIdx
    var nOpt =
      BOOT.plan && BOOT.plan.variants[0] && BOOT.plan.variants[0].options
        ? BOOT.plan.variants[0].options.length
        : 0
    var otherIdxs = []
    for (var oi = 0; oi < nOpt; oi++) {
      // 料金カテゴリー軸はプラン軸にもその他軸にもしない（選択チップに出さない）
      if (oi !== peopleIdx && oi !== pricingIdx) otherIdxs.push(oi)
    }
    var primaryIdx = otherIdxs.length ? otherIdxs[0] : null
    var extraIdxs = otherIdxs.slice(1)

    var planTypes =
      BOOT.plan && primaryIdx != null
        ? distinct(
            BOOT.plan.variants.map(function (v) {
              return (v.options || [])[primaryIdx]
            })
          )
        : BOOT.plan
          ? distinct(
              BOOT.plan.variants.map(function (v) {
                return v.title
              })
            )
          : []

    // その他軸（3つ目以降）。STEP1 でチップ選択させる。
    var extraAxes = extraIdxs.map(function (idx) {
      return {
        index: idx,
        name: optNames[idx] || 'オプション' + (idx + 1),
        values: distinct(
          BOOT.plan.variants.map(function (v) {
            return (v.options || [])[idx]
          })
        ),
      }
    })

    // 値の順序は bootstrap の optionValues を一次ソースにする（variant の走査順から推測すると
    // 先頭組合せの variant が欠番のときずれる）。空配列は truthy なので length で判定する。
    var bootPricingValues = ((BOOT.plan && BOOT.plan.optionValues) || [])[
      pricingIdx
    ]
    var pricingValues = !hasPricingAxis
      ? []
      : bootPricingValues && bootPricingValues.length
        ? bootPricingValues
        : distinct(
            BOOT.plan.variants.map(function (v) {
              return (v.options || [])[pricingIdx]
            })
          )
    // 既定カテゴリー = option 値の先頭。V2 の hidden <select> の初期値と同じ並び順になる。
    var defaultPricingCategory = pricingValues.length ? pricingValues[0] : null

    // availabilityVariant と representativeVariants で代表カテゴリーの選び方を別々に書くと
    // 横断グリッドと週次取得で別の variant を掴むため、順位付けを 1 箇所に寄せる。
    var pricingRankMap = {}
    pricingValues.forEach(function (val, i) {
      pricingRankMap[String(val)] = i
    })
    function pricingRank(opts) {
      if (!hasPricingAxis) return 0
      var r = pricingRankMap[String((opts || [])[pricingIdx])]
      return r === undefined ? pricingValues.length : r
    }

    var PRICING_SIBLING_FIELDS = [
      'openingTime',
      'closingTime',
      'unitMinutes',
      'durationMinutes',
    ]

    // 料金カテゴリー以外の軸の値が同じ variant をまとめる。
    function groupVariantsByNonPricingAxes() {
      var groups = {}
      ;((BOOT.plan && BOOT.plan.variants) || []).forEach(function (v) {
        var opts = v.options || []
        var key = []
        for (var i = 0; i < opts.length; i++) {
          if (i !== pricingIdx) key.push(String(opts[i]))
        }
        var k = key.join('|')
        if (!groups[k]) groups[k] = []
        groups[k].push(v)
      })
      return groups
    }

    // 同じ軸組の variant 間で field が食い違う最初の 1 組を文字列で返す（無ければ null）。
    function describeReservationDiff(variants, field) {
      var baseVal = (variants[0].reservation || {})[field]
      for (var i = 1; i < variants.length; i++) {
        var val = (variants[i].reservation || {})[field]
        if (val !== baseVal) {
          return (
            variants[0].variantId +
            '=' +
            baseVal +
            ' / ' +
            variants[i].variantId +
            '=' +
            val
          )
        }
      }
      return null
    }

    // A1（カテゴリーだけが違う variant 間で空き状況が同一）の部分検出。bootstrap に出ている
    // 4 値しか見ないので、google_calendar_id 等の差は検出できず商品設定の点検は省けない。
    function warnIfPricingSiblingsDiffer() {
      var groups = groupVariantsByNonPricingAxes()
      Object.keys(groups).forEach(function (k) {
        PRICING_SIBLING_FIELDS.forEach(function (f) {
          var diff = describeReservationDiff(groups[k], f)
          if (diff) {
            console.warn(
              '[pricing-category] reservation.' +
                f +
                ' differs within ' +
                k +
                ': ' +
                diff
            )
          }
        })
      })
    }
    if (hasPricingAxis) warnIfPricingSiblingsDiffer()

    // バリアントの「その他軸（extra）」値を extraIdxs 順に結合したキー。
    // representativeVariants の extraKey と同形式（calendar_first のスロット絞り込みに使う）。
    function variantExtraKey(v) {
      var opts = v.options || []
      var parts = []
      for (var k = 0; k < extraIdxs.length; k++) {
        parts.push(String(opts[extraIdxs[k]]))
      }
      return parts.join('|')
    }

    var peopleValues =
      BOOT.plan && peopleIdx != null
        ? distinct(
            BOOT.plan.variants.map(function (v) {
              return parseInt((v.options || [])[peopleIdx], 10)
            })
          )
            .filter(function (n) {
              return !isNaN(n)
            })
            .sort(function (a, b) {
              return a - b
            })
        : [1]

    var peopleMin = peopleValues[0] || 1
    var peopleMax = peopleValues[peopleValues.length - 1] || 1

    // 当初UI: 常にモーダル内 STEP1(プラン選択)から開始する。
    var initialExtraChoice = {}
    extraAxes.forEach(function (a) {
      initialExtraChoice[a.index] = a.values[0]
    })
    var initialSel = {
      planType: planTypes[0] || null,
      people:
        Math.min(2, peopleMax) >= peopleMin
          ? Math.min(2, peopleMax)
          : peopleMin,
    }

    // ---- option grouping ------------------------------------
    function optionGroups() {
      var byCat = {}
      ;(BOOT.options || []).forEach(function (p) {
        var c = p.category || 'other'
        if (!byCat[c])
          byCat[c] = {
            category: c,
            required: false,
            sort: p.sort || 100,
            items: [],
          }
        if (p.required) byCat[c].required = true
        byCat[c].sort = Math.min(byCat[c].sort, p.sort || 100)
        byCat[c].items.push(p)
      })
      return Object.keys(byCat)
        .map(function (k) {
          return byCat[k]
        })
        .sort(function (a, b) {
          return a.sort - b.sort
        })
    }

    var availAdapter = window.ReservationAvailability.create({
      base: BOOT.appProxyBase || '/apps/api',
      productId: BOOT.plan ? BOOT.plan.productId : null,
    })

    var currencyFmt = (function () {
      try {
        return new Intl.NumberFormat('ja-JP', {
          style: 'currency',
          currency: BOOT.currency || 'JPY',
        })
      } catch (e) {
        return null
      }
    })()

    function toIso(apiStr) {
      if (!apiStr) return ''
      var s = String(apiStr).replace(' ', 'T')
      if (/T\d{2}:\d{2}$/.test(s)) s += ':00'
      return s
    }
    function uuid() {
      if (window.crypto && window.crypto.randomUUID)
        return window.crypto.randomUUID()
      return (
        'b' +
        Date.now().toString(16) +
        Math.floor(Math.random() * 1e9).toString(16)
      )
    }

    var app = window.Vue.createApp({
      data: function () {
        return {
          boot: BOOT,
          flowOrder: normalizeFlowOrder(BOOT.flowOrder),
          step: 1, // 1始まりの「位置」。画面キーは stepKey(computed)で導出する
          planTypes: planTypes,
          planType: initialSel.planType,
          extraAxes: extraAxes,
          extraChoice: initialExtraChoice,
          // 料金カテゴリー（日別料金）。軸なし商品では false / [] / null で no-op。
          hasPricingAxis: hasPricingAxis,
          pricingValues: pricingValues,
          defaultPricingCategory: defaultPricingCategory,
          people: initialSel.people,
          peopleMin: peopleMin,
          peopleMax: peopleMax,
          weekStart: U.startOfWeek(new Date()),
          grid: null,
          loadingWeek: false,
          weekError: null,
          revalidating: false, // calendar_first: 確定スロット再検証中(DD5)
          planError: null, // calendar_first: 再検証 fail-closed / 候補不可メッセージ
          // plan_first={iso,slot,pricingCategory} / calendar_first={iso,slotStart,reps,slot,pricingCategory}
          // pricingCategory は日時選択と同じ寿命にする（別持ちだと破棄漏れで日付と食い違う）。
          selected: null,
          options: {}, // productId -> { [variantId]: qty }  (qty>0 のみ保持)
          expanded: {}, // productId -> bool (複数バリアント時の展開状態)
          submitting: false,
          submitError: null,
          WD: WD,
        }
      },
      created: function () {
        // 初期既定値（planTypes[0] / 各 extra 軸の先頭値 / people）が実在しない
        // 組み合わせを指す場合に備え、マウント前に有効な組み合わせへ整合する。
        this.reconcileSelections()
      },
      // calendar_first の下流再整合（6.2/5.4）。
      // 起点=上流（プラン/その他軸/人数）の変更、反応=確定済みスロットの無効化。
      // これにより options/confirm へは proceedFromPlan の再検証成功後のみ進める。
      // plan_first は invalidateConfirmedSlot 内で早期 return するため対象外（1:1温存）。
      watch: {
        planType: function () {
          this.invalidateConfirmedSlot()
        },
        people: function () {
          this.invalidateConfirmedSlot()
        },
        extraChoice: {
          handler: function () {
            this.invalidateConfirmedSlot()
          },
          deep: true,
        },
        // computed 内の console.warn は Vue のキャッシュで「再評価されたときだけ出る」ので、
        // カテゴリー解決の警告は watch 側に置く。
        planVariant: function () {
          this.warnPricingResolution()
        },
        // planVariant だけでは取りこぼす。既定カテゴリー表示中に option に無いカテゴリーの
        // 日付を選ぶと、フォールバック結果が同じ variant のままで発火しない。
        effectivePricingCategory: function () {
          this.warnPricingResolution()
        },
      },
      computed: {
        // ---- フロー別ステップモデル（宣言的） ----
        steps: function () {
          return FLOWS[this.flowOrder] || FLOWS.plan_first
        },
        stepCount: function () {
          return this.steps.length
        },
        stepIndex: function () {
          return this.step - 1 // 0始まり（step は 1始まり位置）
        },
        stepKey: function () {
          return this.steps[this.stepIndex] || this.steps[0]
        },
        // 現ステップの確定可否を集約（無効なら前進・カートインへの遷移を抑止）。
        canAdvance: function () {
          switch (this.stepKey) {
            case 'plan':
              return !!this.planVariant
            case 'calendar':
              // plan_first は確定スロット、calendar_first は開始時刻(rep集合)の選択で前進可
              if (this.flowOrder === 'calendar_first') {
                return !!(
                  this.selected &&
                  this.selected.reps &&
                  this.selected.reps.length
                )
              }
              return !!(this.selected && this.selected.slot)
            case 'options':
              return this.missingRequired.length === 0
            case 'confirm':
              return !this.submitting
            default:
              return true
          }
        },
        groups: function () {
          return optionGroups()
        },
        requiredCategories: function () {
          return this.groups
            .filter(function (g) {
              return g.required
            })
            .map(function (g) {
              return g.category
            })
        },
        // 確定後の参照元にはしない。グリッドは週移動で差し替わるため、選んだ日が
        // 載っていない週では引けなくなる（selectCell で selected へ取り込む）。
        pricingCategoryByIso: function () {
          var map = {}
          if (!hasPricingAxis || !this.grid || !this.grid.header) return map
          this.grid.header.forEach(function (h) {
            if (h && h.pricingCategory != null) map[h.iso] = h.pricingCategory
          })
          return map
        },
        effectivePricingCategory: function () {
          if (!hasPricingAxis) return null
          return (
            (this.selected && this.selected.pricingCategory) ||
            defaultPricingCategory
          )
        },
        // calendar_first の STEP2 でも「〜」は付けない。日付が先に確定しているため
        // 「未確定」の表示が誤情報になる（フロー別の分岐は持たせない）。
        isPricingResolved: function () {
          return (
            hasPricingAxis && !!(this.selected && this.selected.pricingCategory)
          )
        },
        // 文字列を 1 つに集約する。テンプレートに条件式を置くと表示箇所の網羅漏れが起きる。
        priceSuffix: function () {
          if (!hasPricingAxis || this.isPricingResolved) return ''
          return this.t('price_approx', '〜')
        },
        planVariant: function () {
          var sel = {
            planType: this.planType,
            extraChoice: this.extraChoice,
            people: this.people,
            pricingCategory: this.effectivePricingCategory,
          }
          var v = this.resolveVariant(sel)
          if (v) return v
          // 解決できないカテゴリー（option に無い値・特日名の不一致・欠番）は既定へ寄せる。
          // null を返すと価格が消え、カテゴリーはユーザーが変えられないので詰まる。
          if (
            hasPricingAxis &&
            sel.pricingCategory !== defaultPricingCategory
          ) {
            return this.resolveVariant(
              Object.assign({}, sel, {
                pricingCategory: defaultPricingCategory,
              })
            )
          }
          return null
        },
        // 空き枠取得はカテゴリーを option 値の固定順で決める。日付依存にすると週次 API の
        // キャッシュキーがカテゴリー数に増える。
        availabilityVariant: function () {
          if (!hasPricingAxis) return this.planVariant
          var sel = {
            planType: this.planType,
            extraChoice: this.extraChoice,
            people: this.people,
          }
          for (var i = 0; i < pricingValues.length; i++) {
            var v = this.resolveVariant(
              Object.assign({}, sel, { pricingCategory: pricingValues[i] })
            )
            if (v) return v
          }
          // planVariant へは寄せない（取得 variant が日付依存に戻る）。1 本も無いのは軸の
          // 組合せ自体が無いときで、planVariant も null になり既存のガードが効く。
          return null
        },
        // calendar_first STEP1 用の代表バリアント集合。
        // 全 variant を planType×extra軸 で集約し、各組の「最小人数」バリアント1本を
        // 代表に選ぶ（A1: 人数は空きに影響せず料金のみ → 人数次元を横断フェッチから除外）。
        // 料金カテゴリーは順位で代表を絞る。既定カテゴリーだけに限ると、既定が欠番の
        // planType×extra 組が横断グリッドとプラン候補から無言で消える。
        representativeVariants: function () {
          if (!this.boot.plan) return []
          var groups = {}
          this.boot.plan.variants.forEach(function (v) {
            var opts = v.options || []
            var planType =
              primaryIdx != null ? String(opts[primaryIdx]) : String(v.title)
            var extraKey = variantExtraKey(v)
            var key = planType + '||' + extraKey
            var people =
              peopleIdx != null ? parseInt(opts[peopleIdx], 10) : NaN
            // 軸なし商品では常に 0 なので、下の条件は現行の「最小人数」判定に一致する。
            var catRank = pricingRank(opts)
            var cur = groups[key]
            // 未登録 or カテゴリー順位が上 or 同順位でより小さい人数なら代表を更新
            if (
              !cur ||
              catRank < cur.catRank ||
              (catRank === cur.catRank &&
                !isNaN(people) &&
                (isNaN(cur.people) || people < cur.people))
            ) {
              groups[key] = {
                variantId: v.variantId,
                planType: planType,
                extraKey: extraKey,
                people: people,
                catRank: catRank,
              }
            }
          })
          return Object.keys(groups).map(function (k) {
            var g = groups[k]
            return {
              variantId: g.variantId,
              planType: g.planType,
              extraKey: g.extraKey,
            }
          })
        },
        // calendar_first STEP2: 選択スロットの rep 集合から「選べる planType」を導出（3.1）。
        // 表示順は planTypes の並びを保つ。0件なら選び直し導線へ（3.2）。
        slotPlanCandidates: function () {
          if (!this.selected || !this.selected.reps) return []
          var repMap = {}
          this.representativeVariants.forEach(function (r) {
            repMap[r.variantId] = r
          })
          var present = {}
          this.selected.reps.forEach(function (sr) {
            var rv = repMap[sr.variantId]
            if (rv) present[rv.planType] = true
          })
          return this.planTypes.filter(function (pt) {
            return present[pt]
          })
        },
        // calendar_first: 選択スロットの reps（＝その日時に枠を持つ代表）のうち、現 planType に
        // 一致するものの extraKey 集合。extra 軸を「選択日時に存在する組み合わせ」だけに絞る（A3対応）。
        // plan_first は null（制約なし＝従来どおり全 extra 値を表示）。
        slotAllowedKeys: function () {
          if (this.flowOrder !== 'calendar_first') return null
          if (!this.selected || !this.selected.reps || !this.selected.reps.length)
            return null
          var repMap = {}
          this.representativeVariants.forEach(function (r) {
            repMap[r.variantId] = r
          })
          var self = this
          var set = {}
          this.selected.reps.forEach(function (sr) {
            var rv = repMap[sr.variantId]
            if (rv && String(rv.planType) === String(self.planType)) {
              set[rv.extraKey] = true
            }
          })
          return set
        },
        // プラン選択肢: plan_first=全 planTypes / calendar_first=選択スロットの候補のみ。
        planTypeChoices: function () {
          return this.flowOrder === 'calendar_first'
            ? this.slotPlanCandidates
            : this.planTypes
        },
        // calendar_first STEP2 見出し用: 選択日時のラベル（slot 確定前のため iso+slotStart から生成）
        selectedSlotLabel: function () {
          if (!this.selected) return ''
          var ss = this.selected.slotStart || ''
          // slotStart は 24 時間超表記なので "iso + slotStart" は Date 化できない。
          var d = U.parseYmd(this.selected.iso)
          if (!d) return ss
          return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日（' +
            WD[d.getDay()] +
            '） ' +
            ss
          )
        },
        // ---- バリエーション絞り込み（バリアントデータを唯一の正とする） ----
        // 上流の選択（プラン軸＝primaryIdx／先行する extra 軸）に対して、
        // 実在するバリアントの組み合わせだけから各 extra 軸の選択肢を導出する。
        // ラベルの文字列マッチングは使わず、必ず variant.options の値で判定する。
        // → 月〜金プラン選択時に土・日の時間帯を出さない等のバグを防ぐ。
        extraAxesView: function () {
          var self = this
          var slotKeys = this.slotAllowedKeys // calendar_first のみ非 null
          return extraAxes.map(function (axis, k) {
            var valid = {}
            ;(self.boot.plan ? self.boot.plan.variants : []).forEach(function (
              v
            ) {
              var opts = v.options || []
              // プラン軸が一致しないバリアントは除外
              if (
                primaryIdx != null &&
                String(opts[primaryIdx]) !== String(self.planType)
              ) {
                return
              }
              // calendar_first: 選択日時に枠を持たない (planType×extra) の組合せは除外（A3）
              if (slotKeys && !slotKeys[variantExtraKey(v)]) return
              // この軸より前（上流）の extra 軸が選択値と一致しないものを除外
              for (var j = 0; j < k; j++) {
                var pix = extraIdxs[j]
                if (String(opts[pix]) !== String(self.extraChoice[pix])) return
              }
              valid[String(opts[axis.index])] = true
            })
            return {
              index: axis.index,
              name: axis.name,
              // 元の軸の値順を保ったまま、実在する組み合わせのみ残す
              values: axis.values.filter(function (val) {
                return valid[String(val)]
              }),
            }
          })
        },
        // 現在のプラン軸＋全 extra 軸選択に対して実在する人数（peopleIdx 軸）の集合
        availablePeople: function () {
          var self = this
          if (peopleIdx == null) return peopleValues
          var set = {}
          ;(this.boot.plan ? this.boot.plan.variants : []).forEach(function (v) {
            var opts = v.options || []
            if (
              primaryIdx != null &&
              String(opts[primaryIdx]) !== String(self.planType)
            ) {
              return
            }
            for (var j = 0; j < extraIdxs.length; j++) {
              var pix = extraIdxs[j]
              if (String(opts[pix]) !== String(self.extraChoice[pix])) return
            }
            var n = parseInt(opts[peopleIdx], 10)
            if (!isNaN(n)) set[n] = true
          })
          var out = peopleValues.filter(function (n) {
            return set[n]
          })
          return out.length ? out : peopleValues
        },
        peopleFloor: function () {
          var a = this.availablePeople
          return a.length ? a[0] : this.peopleMin
        },
        peopleCeil: function () {
          var a = this.availablePeople
          return a.length ? a[a.length - 1] : this.peopleMax
        },
        // 人数をバリアント軸として選ばせる商品か。人数軸が無い商品（BBQ 等）では
        // people は初期値(1)のまま実選択を反映しないため、「1名」を画面に出さない。
        hasPeopleAxis: function () {
          return peopleIdx != null
        },
        // plan_first STEP1 の見出し。テンプレート設定「サウナの予約」OFF の商品は汎用文言にする。
        bookingTitle: function () {
          return this.boot.isSauna === false
            ? this.t('title_generic', '予約する')
            : this.t('title', 'サウナを予約する')
        },
        // STEP2/3/4 の見出し用ラベル（プラン＋その他軸を結合）
        planLabel: function () {
          var parts = []
          if (this.planType) parts.push(this.planType)
          for (var k = 0; k < extraIdxs.length; k++) {
            var v = this.extraChoice[extraIdxs[k]]
            if (v) parts.push(v)
          }
          return parts.join(' / ')
        },
        planPrice: function () {
          return this.planVariant ? this.planVariant.price : 0
        },
        optionsSubtotal: function () {
          var sum = 0
          var map = this.optionVariantMap
          for (var pid in this.options) {
            var vs = this.options[pid]
            for (var vid in vs) {
              var v = map[vid]
              if (v) sum += v.price * vs[vid]
            }
          }
          return sum
        },
        optionsCount: function () {
          var c = 0
          for (var pid in this.options) {
            var vs = this.options[pid]
            for (var vid in vs) c += vs[vid]
          }
          return c
        },
        total: function () {
          return this.planPrice + this.optionsSubtotal
        },
        optionVariantMap: function () {
          var map = {}
          ;(this.boot.options || []).forEach(function (p) {
            ;(p.variants || []).forEach(function (v) {
              map[v.variantId] = v
            })
          })
          return map
        },
        productMap: function () {
          var map = {}
          ;(this.boot.options || []).forEach(function (p) {
            map[p.productId] = p
          })
          return map
        },
        // 確認シート・履歴表示用に「商品名＋バリアント × 数量」へ平坦化
        optionLines: function () {
          var vmap = this.optionVariantMap
          var pmap = this.productMap
          var out = []
          for (var pid in this.options) {
            var p = pmap[pid]
            var vs = this.options[pid]
            for (var vid in vs) {
              var v = vmap[vid]
              if (!v || vs[vid] <= 0) continue
              var label = p ? p.title : ''
              if (v.label && v.label !== 'Default Title') {
                label = label ? label + ' ' + v.label : v.label
              }
              out.push({
                label: label,
                qty: vs[vid],
                price: v.price,
                lineTotal: v.price * vs[vid],
              })
            }
          }
          return out
        },
        weekLabel: function () {
          // 月をまたぐ場合も区切り表記を「◯月◯日」に統一する（"月" と "/" の混在を避ける）
          var a = this.weekStart
          var b = U.addDays(a, 6)
          var left = a.getMonth() + 1 + '月' + a.getDate() + '日'
          var right =
            b.getMonth() === a.getMonth()
              ? b.getDate() + '日'
              : b.getMonth() + 1 + '月' + b.getDate() + '日'
          return left + '–' + right
        },
        atMinWeek: function () {
          return this.weekStart.getTime() <= U.startOfWeek(new Date()).getTime()
        },
        hasAnyOpen: function () {
          if (!this.grid) return false
          return this.grid.rows.some(function (r) {
            return r.cells.some(function (c) {
              return c.selectable
            })
          })
        },
        missingRequired: function () {
          var chosen = {}
          var optMeta = {}
          ;(this.boot.options || []).forEach(function (p) {
            optMeta[p.productId] = p.category
          })
          for (var pid in this.options) {
            var vs = this.options[pid]
            var any = false
            for (var vid in vs) {
              if (vs[vid] > 0) {
                any = true
                break
              }
            }
            if (any) chosen[optMeta[pid]] = true
          }
          return this.requiredCategories.filter(function (c) {
            return !chosen[c]
          })
        },
        selectedView: function () {
          if (!this.selected || !this.selected.slot) return null
          var s = this.selected.slot
          // 基準日は暦日（start_at）ではなく営業日。iso を持たない経路だけ暦日に落とす。
          var d = U.parseYmd(this.selected.iso) || U.parseApiDate(s.start_at)
          if (!d || isNaN(d.getTime())) return null
          var base = U.ymd(d)
          return {
            dateLabel: d.getMonth() + 1 + '月' + d.getDate() + '日',
            wd: WD[d.getDay()],
            weekend: d.getDay() === 0 || d.getDay() === 6,
            start: U.slotKey(base, s.start_at),
            end: U.slotKey(base, s.end_at),
          }
        },
      },
      methods: {
        money: function (cents) {
          if (currencyFmt) return currencyFmt.format((cents || 0) / 100)
          return '¥' + Math.round((cents || 0) / 100).toLocaleString('ja-JP')
        },
        // 上流（プラン軸／extra 軸）の選択が変わったとき、下流の extra 軸選択と
        // 人数を「実在する組み合わせ」に再整合する。存在しない選択値は元の軸順の
        // 先頭の有効値へ寄せる（＝常に有効なバリアントを指す状態を保つ）。
        // 判定は必ず variant.options で行い、ラベル文字列には依存しない。
        reconcileSelections: function () {
          var self = this
          var slotKeys = this.slotAllowedKeys // calendar_first のみ非 null
          for (var k = 0; k < extraIdxs.length; k++) {
            var idx = extraIdxs[k]
            var valid = {}
            ;(this.boot.plan ? this.boot.plan.variants : []).forEach(function (
              v
            ) {
              var opts = v.options || []
              if (
                primaryIdx != null &&
                String(opts[primaryIdx]) !== String(self.planType)
              ) {
                return
              }
              // calendar_first: 選択日時に枠を持たない組合せは除外（A3）
              if (slotKeys && !slotKeys[variantExtraKey(v)]) return
              for (var j = 0; j < k; j++) {
                var pix = extraIdxs[j]
                if (String(opts[pix]) !== String(self.extraChoice[pix])) return
              }
              valid[String(opts[idx])] = true
            })
            if (!valid[String(this.extraChoice[idx])]) {
              var firstValid = extraAxes[k].values.filter(function (val) {
                return valid[String(val)]
              })[0]
              this.extraChoice[idx] = firstValid != null ? firstValid : null
            }
          }
          // 人数を現在の組み合わせで実在する範囲へクランプ
          if (peopleIdx != null) {
            var avail = this.availablePeople
            if (avail.length && avail.indexOf(this.people) === -1) {
              this.people = avail[0]
            }
          }
        },
        selectPlanType: function (t) {
          this.planType = t
          this.reconcileSelections() // 上流変更 → 下流 extra 軸／人数を再整合
          // plan_first はプランが上流のため日時(selected)をリセット。
          // calendar_first は日時が上流のため selected を保持し、再検証エラーのみ解除。
          if (this.flowOrder === 'calendar_first') this.planError = null
          else this.selected = null
        },
        getExtra: function (axisIndex) {
          return this.extraChoice[axisIndex]
        },
        setExtra: function (axisIndex, val) {
          this.extraChoice[axisIndex] = val
          this.reconcileSelections() // この軸より下流の extra 軸／人数を再整合
          if (this.flowOrder === 'calendar_first') this.planError = null
          else this.selected = null // plan_first: 上流変更で下流リセット
        },
        changePeople: function (delta) {
          // 人数は非連続になり得る（実在する人数集合のみ）。集合内をステップ移動する。
          var avail = this.availablePeople
          if (!avail.length) return
          // calendar_first は「人数=料金のみ・日時不変」(3.5)。selected は保持する。
          var cf = this.flowOrder === 'calendar_first'
          var i = avail.indexOf(this.people)
          if (i === -1) {
            this.people = avail[0]
            if (cf) this.planError = null
            else this.selected = null
            return
          }
          var ni = i + delta
          if (ni < 0) ni = 0
          if (ni >= avail.length) ni = avail.length - 1
          if (avail[ni] !== this.people) {
            this.people = avail[ni]
            if (cf) this.planError = null
            else this.selected = null
          }
        },
        // 価格表示・カート投入・空き枠取得の variant 解決はすべてここを通す（分かれると
        // 表示価格と課金がずれる）。判定はラベル文字列ではなく variant.options の値で行う。
        resolveVariant: function (sel) {
          if (!this.boot.plan) return null
          var extraChoice = sel.extraChoice || {}
          return (
            this.boot.plan.variants.filter(function (v) {
              var opts = v.options || []
              // プラン軸
              if (
                primaryIdx != null &&
                String(opts[primaryIdx]) !== String(sel.planType)
              ) {
                return false
              }
              // その他軸（3つ目以降）
              for (var k = 0; k < extraIdxs.length; k++) {
                var ix = extraIdxs[k]
                if (String(opts[ix]) !== String(extraChoice[ix])) return false
              }
              // 人数軸
              if (
                peopleIdx != null &&
                parseInt(opts[peopleIdx], 10) !== sel.people
              ) {
                return false
              }
              // 料金カテゴリー軸（軸なし商品では比較しない＝現行と同じ絞り込み）
              if (
                hasPricingAxis &&
                String(opts[pricingIdx]) !== String(sel.pricingCategory)
              ) {
                return false
              }
              return true
            })[0] || null
          )
        },
        // 既定カテゴリーへ寄せたことを無言にしない。要求カテゴリーと解決結果の食い違いだけが
        // 特日名の設定ミス（最も金額影響が大きい）の手がかりになる。
        warnPricingResolution: function () {
          if (!hasPricingAxis) return
          var v = this.planVariant
          if (!v) return
          var want = this.effectivePricingCategory
          var got = (v.options || [])[pricingIdx]
          if (String(got) !== String(want)) {
            console.warn(
              '[pricing-category] variant not found for ' +
                this.planLabel +
                ' / ' +
                want +
                ' (fallback to ' +
                got +
                ')'
            )
          }
          if (v.available === false) {
            console.warn(
              '[pricing-category] resolved variant is unavailable ' +
                v.variantId
            )
          }
        },
        goToCalendar: function () {
          if (!this.availabilityVariant) return
          this.step = 2
          this.loadWeek()
        },
        loadWeek: function () {
          var self = this
          if (!this.availabilityVariant) return
          this.loadingWeek = true
          this.weekError = null
          // 発行時点のリクエスト識別子。週移動やプラン変更の連打で
          // 古いレスポンス/エラーが現在の表示を上書きしないよう成功・失敗の両方でガードする。
          var reqVariantId = this.availabilityVariant.variantId
          var reqWeekStart = this.weekStart
          function isStale() {
            return (
              !self.availabilityVariant ||
              reqVariantId !== self.availabilityVariant.variantId ||
              reqWeekStart.getTime() !== self.weekStart.getTime()
            )
          }
          availAdapter
            .fetchWeek({
              variantId: reqVariantId,
              weekStart: reqWeekStart,
            })
            .then(function (week) {
              if (isStale()) return
              // グリッド行は API timeSlots の和集合のみで導出（候補枠のクライアント計算はしない）
              self.grid = availAdapter.deriveGrid(week, { now: new Date() })
              self.loadingWeek = false
              self.weekError = null
              availAdapter.prefetchAdjacentWeeks({
                variantId: self.availabilityVariant.variantId,
                weekStart: self.weekStart,
              })
            })
            .catch(function (err) {
              if (err && err.kind === 'abort') return
              if (isStale()) return
              self.loadingWeek = false
              self.grid = null
              self.weekError = self.t(
                'err_avail',
                '空き状況を取得できませんでした。時間をおいて再度お試しください。'
              )
              console.error('availability error', err)
            })
        },
        // フロー別の週読込ディスパッチャ。plan_first=単一(loadWeek)、calendar_first=横断(loadWeekMulti)。
        // 週ナビ・再試行・初期表示はすべてこの1箇所を経由して経路分岐する。
        loadCurrentWeek: function () {
          if (this.flowOrder === 'calendar_first') this.loadWeekMulti()
          else this.loadWeek()
        },
        // calendar_first STEP1: 代表バリアントを横断フェッチし、和集合グリッドを描画する。
        loadWeekMulti: function () {
          var self = this
          var reps = this.representativeVariants
          if (!reps.length) {
            this.grid = null
            this.weekError = this.t(
              'err_avail',
              '空き状況を取得できませんでした。時間をおいて再度お試しください。'
            )
            return
          }
          this.loadingWeek = true
          this.weekError = null
          // 発行時点の週を退避。週連打で古いレスポンス/エラーが
          // 現在表示中の週を上書きしないよう成功・失敗の両方でガードする。
          var reqWeekStart = this.weekStart
          function isStale() {
            return reqWeekStart.getTime() !== self.weekStart.getTime()
          }
          availAdapter
            .fetchWeekMulti({ variants: reps, weekStart: reqWeekStart })
            .then(function (week) {
              if (isStale()) return
              self.grid = availAdapter.deriveGridMulti(week, {
                now: new Date(),
                reps: reps,
              })
              self.loadingWeek = false
              // multi の隣接週 prefetch は既定 off（DD6: 負荷増大と fail-closed 失敗率増を回避）
            })
            .catch(function (err) {
              if (err && err.kind === 'abort') return
              if (isStale()) return
              self.loadingWeek = false
              self.grid = null
              self.weekError = self.t(
                'err_avail',
                '空き状況を取得できませんでした。時間をおいて再度お試しください。'
              )
              console.error('availability(multi) error', err)
            })
        },
        prevWeek: function () {
          if (this.atMinWeek) return
          // calendar_first は週変更で選択日時を破棄（5.2: 下流再整合の起点）
          if (this.flowOrder === 'calendar_first') this.selected = null
          this.weekStart = U.addDays(this.weekStart, -7)
          this.loadCurrentWeek()
        },
        nextWeek: function () {
          if (this.flowOrder === 'calendar_first') this.selected = null
          this.weekStart = U.addDays(this.weekStart, 7)
          this.loadCurrentWeek()
        },
        selectCell: function (cell) {
          if (!cell.selectable) return
          // 料金カテゴリーはチェックイン日で決まる。グリッドは週移動で差し替わるので
          // ここで選択状態に取り込む（以降はグリッドから都度導出しない）。
          var cat = null
          if (hasPricingAxis) {
            cat = this.pricingCategoryByIso[cell.iso]
            if (!cat) {
              console.warn('[pricing-category] no category for ' + cell.iso)
              cat = defaultPricingCategory
            }
          }
          if (this.flowOrder === 'calendar_first') {
            // 開始時刻＋対応 rep 集合を保持（確定スロットは STEP2 のプラン確定時に解決）
            // 行キーと同じ表記で持つ。暦日に丸めると日またぎ枠が再検証で一致しない。
            var ss =
              cell.reps && cell.reps[0]
                ? U.slotKey(cell.iso, cell.reps[0].slot.start_at)
                : ''
            this.selected = {
              iso: cell.iso,
              slotStart: ss,
              reps: cell.reps || [],
              slot: null,
              pricingCategory: cat,
            }
            this.planError = null
            // 選択日時の候補に現在の planType が無ければ先頭候補へ補正
            var cands = this.slotPlanCandidates
            if (cands.length && cands.indexOf(this.planType) === -1) {
              this.planType = cands[0]
            }
            // planType 変更有無に関わらず、extra 軸/人数を「選択した日時に存在する組合せ」へ
            // 再整合する（A3: 選択スロットに無い利用時間などを残さない）。
            this.reconcileSelections()
            this.advance() // calendar(STEP1) → plan(STEP2)
            this.emit('dispatch:reservation:slot_selected')
            return
          }
          // plan_first（既存挙動を温存）
          this.selected = {
            iso: cell.iso,
            slot: cell.slot,
            pricingCategory: cat,
          }
          this.step = 3
          this.emit('dispatch:reservation:slot_selected')
        },
        // calendar_first STEP2: プラン人数確定 → 確定スロットのランタイム再検証(DD5)。
        // 実バリアントで fetchWeek を1回呼び、選択スロット(start_at一致)が実在するか確認。
        // 実在ならその variant 由来 slot で確定し options へ。不在/失敗は fail-closed（選び直し）。
        // 代表=実バリアント時はキャッシュヒットで追加コストほぼゼロ。
        proceedFromPlan: function () {
          var self = this
          if (this.flowOrder !== 'calendar_first') return
          if (!this.selected || this.revalidating) return
          if (!this.planVariant) return
          var startWanted = this.selected.slotStart
          var isoWanted = this.selected.iso
          var weekWanted = this.weekStart
          // リクエスト発行時のコンテキストを退避。再検証中に「戻る」で別セル選択・
          // planType/people/extra 変更が起きても、古い応答が現在状態へ無条件適用
          // されるのを防ぐ（古い再検証応答のクライアント側適用の抑止。
          // 再検証成功〜カート投入の間に枠が埋まる残余レースは残る: design.md DD5 追補）。
          var reqVariantId = this.planVariant.variantId
          var reqPlanType = this.planType
          function isStale() {
            return (
              !self.selected ||
              self.selected.iso !== isoWanted ||
              self.selected.slotStart !== startWanted ||
              self.weekStart !== weekWanted ||
              !self.planVariant ||
              self.planVariant.variantId !== reqVariantId ||
              self.planType !== reqPlanType
            )
          }
          this.planError = null
          this.revalidating = true
          availAdapter
            .fetchWeek({
              variantId: this.planVariant.variantId,
              weekStart: this.weekStart,
              // 確定直前の最終判定は 10 分キャッシュを使わず必ずサーバ最新応答で行う
              // （キャッシュ済みだと最大 10 分前の枠を「実在」と誤判定しうるため）。
              forceRefresh: true,
            })
            .then(function (week) {
              self.revalidating = false
              if (isStale()) return
              var entry = (week.days || {})[isoWanted]
              var found = null
              if (entry && entry.timeSlots) {
                for (var i = 0; i < entry.timeSlots.length; i++) {
                  if (
                    U.slotKey(isoWanted, entry.timeSlots[i].start_at) ===
                    startWanted
                  ) {
                    found = entry.timeSlots[i]
                    break
                  }
                }
              }
              if (found) {
                self.selected = Object.assign({}, self.selected, {
                  slot: found,
                })
                self.advance() // plan(STEP2) → options(STEP3)
              } else {
                // fail-closed: 枠消失/当該プランでは選べない
                self.planError = self.t(
                  'cf_slot_taken',
                  'この枠は埋まりました。日時を選び直してください。'
                )
              }
            })
            .catch(function (err) {
              self.revalidating = false
              if (err && err.kind === 'abort') return
              if (isStale()) return
              self.planError = self.t(
                'cf_slot_taken',
                'この枠は埋まりました。日時を選び直してください。'
              )
              console.error('revalidate slot error', err)
            })
        },
        // calendar_first: 日時を選び直す（カレンダー STEP1 へ戻り選択をクリア）
        reselectDatetime: function () {
          this.selected = null
          this.planError = null
          this.step = 1
        },
        // calendar_first 専用: 上流変更時に確定済みスロットを無効化する（下流再整合）。
        // 確定後にプラン/人数/その他軸を変えた場合、再検証(proceedFromPlan)を経るまで
        // options/confirm へ進ませない。plan_first は対象外。
        invalidateConfirmedSlot: function () {
          if (this.flowOrder !== 'calendar_first') return
          if (this.selected && this.selected.slot) {
            this.selected = Object.assign({}, this.selected, { slot: null })
            this.planError = null
          }
        },
        // ---- options（商品×バリアントごとの数量モデル） ----
        firstAvailableVariant: function (p) {
          var v = (p.variants || []).filter(function (x) {
            return x.available
          })[0]
          return v || (p.variants || [])[0] || null
        },
        isMultiVariant: function (p) {
          return (p.variants || []).length > 1
        },
        isUrl: function (s) {
          return typeof s === 'string' && /^https?:\/\//.test(s)
        },
        // p.icon は admin 設定のメタフィールド由来だが、念のためインラインSVG描画前に
        // DOMParser で実際にパースし、SVG系タグの allowlist で再構成する
        // （正規表現の除去はネストタグや属性区切りの揺れで迂回できるため使わない）。
        sanitizeIcon: function (s) {
          if (typeof s !== 'string' || !s) return ''
          if (typeof DOMParser === 'undefined') return ''
          var ALLOWED_TAGS = [
            'svg', 'path', 'g', 'circle', 'ellipse', 'rect', 'line',
            'polyline', 'polygon', 'defs', 'lineargradient',
            'radialgradient', 'stop', 'title', 'symbol', 'use',
          ]
          var doc
          try {
            doc = new DOMParser().parseFromString(s, 'text/html')
          } catch (e) {
            return ''
          }
          function clean(node) {
            var els = Array.prototype.slice.call(node.children)
            els.forEach(function (el) {
              if (ALLOWED_TAGS.indexOf(el.tagName.toLowerCase()) === -1) {
                node.removeChild(el)
                return
              }
              Array.prototype.slice.call(el.attributes).forEach(function (attr) {
                var name = attr.name.toLowerCase()
                // 制御文字/空白を除去した上でスキームを判定（エンティティは parse 時点で解決済み）
                var value = String(attr.value).replace(/[\u0000-\u0020]/g, '')
                if (name.indexOf('on') === 0 || /^(javascript|vbscript|data):/i.test(value)) {
                  el.removeAttribute(attr.name)
                }
              })
              clean(el)
            })
          }
          clean(doc.body)
          return doc.body.innerHTML
        },
        // 指定バリアントの選択数量
        variantQty: function (p, variant) {
          var vs = this.options[p.productId]
          return vs && vs[variant.variantId] ? vs[variant.variantId] : 0
        },
        // 商品(全バリアント)の合計数量
        productQty: function (p) {
          var vs = this.options[p.productId]
          if (!vs) return 0
          var c = 0
          for (var vid in vs) c += vs[vid]
          return c
        },
        // バリアント単位の数量上限。min( option.max_qty, 在庫(deny時), 20 )
        maxForVariant: function (p, variant) {
          var caps = [20]
          if (p.maxQty && p.maxQty > 0) caps.push(p.maxQty)
          if (
            variant &&
            variant.managed &&
            variant.policy === 'deny' &&
            typeof variant.inventory === 'number'
          ) {
            caps.push(variant.inventory)
          }
          return Math.max(0, Math.min.apply(null, caps))
        },
        setVariantQty: function (p, variant, delta) {
          if (!variant || !variant.available) return
          var pid = p.productId
          if (!this.options[pid]) this.options[pid] = {}
          var cur = this.options[pid][variant.variantId] || 0
          var max = this.maxForVariant(p, variant)
          var next = cur + delta
          if (next < 0) next = 0
          if (next > max) next = max
          if (next <= 0) {
            delete this.options[pid][variant.variantId]
          } else {
            this.options[pid][variant.variantId] = next
          }
          // 商品の選択が空になったらエントリを削除
          if (Object.keys(this.options[pid]).length === 0) {
            delete this.options[pid]
          }
        },
        toggleExpand: function (p) {
          this.expanded[p.productId] = !this.expanded[p.productId]
        },
        goToConfirm: function () {
          if (this.missingRequired.length) return
          this.submitError = null
          this.step = 4
        },
        backTo: function (n) {
          this.step = n
        },
        // STEP2 から戻る: 当初UIでは常にプラン選択(STEP1)へ戻る
        leaveCalendar: function () {
          this.backTo(1)
        },
        // ヘッダー左の ← で1つ前のステップへ戻る（位置 index 駆動・両フロー共通）
        goBack: function () {
          if (this.step > 1) this.step = this.step - 1
        },
        // 宣言的前進。確定可否(canAdvance)を満たすときだけ次ステップへ進む。
        // calendar_first の各ステップCTA（Task4/5で結線）から利用する。
        advance: function () {
          if (!this.canAdvance) return
          if (this.step < this.stepCount) this.step = this.step + 1
        },
        // ヘッダーの✕でモーダルを閉じる（モーダル制御は initModal 側が購読）
        requestClose: function () {
          try {
            document.dispatchEvent(new CustomEvent('dispatch:reservation:close'))
          } catch (e) {}
        },
        // モーダルを開いたときの初期化: 常に STEP1 から。
        // calendar_first は STEP1 が横断カレンダーのため、開いた時点で読込を開始する。
        open: function () {
          this.step = 1
          if (this.flowOrder === 'calendar_first') {
            this.selected = null
            this.loadCurrentWeek()
          } else if (hasPricingAxis) {
            // 料金カテゴリー軸があるときは plan_first でも日時選択を捨てる（残すと STEP1 に
            // 前回日付のカテゴリー価格が確定表示される）。軸なし商品は現行どおり保持する。
            this.selected = null
          }
        },
        // flow_order=both のとき、クリックされたトリガー（data-reservation-flow）に応じて
        // 実行時フローを切り替える。フローが変わるときは選択状態をリセットして開き直す。
        setFlowOrder: function (f) {
          var nf = f === 'calendar_first' ? 'calendar_first' : 'plan_first'
          if (nf === this.flowOrder) return
          this.flowOrder = nf
          this.selected = null
          this.grid = null
          this.weekError = null
          this.planError = null
          this.step = 1
        },
        // ---- cart ----
        // 親(プラン)明細。bundleId が null のときは _bundle 系を付けない
        // = オプション無しの単独予約はカートで「セット」扱いにしない(#2)。
        buildParentItem: function (bundleId) {
          var notice = this.boot.notice || {}
          var slot = this.selected.slot
          var props = {
            start_at: toIso(slot.start_at),
            end_at: toIso(slot.end_at),
            end_at_with_buffer: toIso(slot.end_at_with_buffer),
            店舗: this.boot.store ? this.boot.store.label : '',
          }
          // 人数がバリアント軸のときはカートのオプション表示と重複するため付けない。
          // 人数軸が無い構成では people は常に初期値(1)で実選択を反映しないため、
          // 実際に人数を選択できる構成（peopleMax > 1）のときだけ付与する。
          if (peopleIdx == null && peopleMax > 1)
            props['人数'] = this.people + '名'
          if (notice.title) props[notice.title] = notice.body
          if (bundleId) {
            props._bundle_id = bundleId
            props._bundle_role = 'parent'
          }
          return {
            id:
              Number(this.planVariant.variantId) || this.planVariant.variantId,
            quantity: 1,
            properties: props,
          }
        },
        buildChildItems: function (bundleId) {
          var items = []
          for (var pid in this.options) {
            var vs = this.options[pid]
            for (var vid in vs) {
              if (vs[vid] <= 0) continue
              items.push({
                id: Number(vid) || vid,
                quantity: vs[vid],
                properties: { _bundle_id: bundleId, _bundle_role: 'child' },
              })
            }
          }
          return items
        },
        addToCart: function (items) {
          var self = this
          // 通信が詰まると submitting が戻らず操作不能になるため、明示タイムアウトを入れる。
          var controller =
            typeof AbortController !== 'undefined' ? new AbortController() : null
          var timer = controller
            ? setTimeout(function () {
                controller.abort()
              }, 15000)
            : null
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            signal: controller ? controller.signal : undefined,
            body: JSON.stringify({ items: items }),
          })
            .then(function (res) {
              if (timer) clearTimeout(timer)
              // エラー体が JSON とは限らない（429/5xx はHTMLの場合がある）ため
              // text→parse で安全に読み、失敗時は定型文言に落とす。
              if (!res.ok) {
                return res.text().then(function (text) {
                  var data = null
                  try {
                    data = JSON.parse(text)
                  } catch (e) {}
                  throw new Error(
                    (data && (data.description || data.message)) ||
                      self.t(
                        'err_cart_add',
                        'カートに追加できませんでした。在庫や空き状況をご確認ください。'
                      )
                  )
                })
              }
              return res.json()
            })
            .catch(function (err) {
              if (timer) clearTimeout(timer)
              if (err && err.name === 'AbortError') {
                throw new Error(
                  self.t(
                    'err_timeout',
                    '通信がタイムアウトしました。時間をおいて再度お試しください。'
                  )
                )
              }
              throw err
            })
        },
        confirm: function () {
          var self = this
          if (this.submitting) return
          if (this.missingRequired.length) {
            this.step = 3
            return
          }
          this.submitting = true
          this.submitError = null

          var hasOptions = Object.keys(this.options).length > 0
          var bundleId = hasOptions ? uuid() : null
          var parent = this.buildParentItem(bundleId)
          var children = hasOptions ? this.buildChildItems(bundleId) : []

          // 親＋子を「単一リクエスト」で投入する（design: 部分追加なし＝アトミック）。
          // /cart/add.js は items[] のいずれか1つでも不可なら 422 で全体が追加されない。
          // 分割投入は親失敗時に削除不能な孤児オプションを残すため採用しない。
          // Shopify は API 2023-10 以降、カート明細を「追加時刻の新しい順（後入れが上）」で
          // 並べ、その順が注文情報にもそのまま引き継がれる。親を配列の最後＝最も新しく追加
          // することで、カート・注文とも先頭を親(メイン商品)に揃える（reverse で [親, 子...] を
          // [子..., 親] に反転して送る）。
          var items = [parent].concat(children)
          items.reverse()
          this.addToCart(items)
            .then(function () {
              self.emit('dispatch:reservation:cart_added')
              window.location.href = '/cart'
            })
            .catch(function (err) {
              self.submitting = false
              self.submitError =
                err.message || self.t('err_cart_add', 'カートに追加できませんでした。')
              console.error('cart add error', err)
            })
        },
        emit: function (name) {
          try {
            document.dispatchEvent(
              new CustomEvent(name, {
                detail: {
                  planVariantId: this.planVariant
                    ? this.planVariant.variantId
                    : null,
                  people: this.people,
                  total: this.total,
                },
              })
            )
          } catch (e) {}
        },
        t: function (key, fallback) {
          var dict = window.RESERVATION_I18N || {}
          return dict[key] || fallback
        },
      },
      template: TEMPLATE(),
    })

    var vm = app.mount('#reservation-booking')
    initModal(vm)
  }

  // ---- modal (商品ページの「予約する」ボタン → モーダル表示) ----------------
  function initModal(vm) {
    var modal = document.querySelector('[data-reservation-modal]')
    var triggers = document.querySelectorAll('[data-reservation-trigger]')
    if (!modal) return

    var panel = modal.querySelector('.rsv-modal__panel')
    var lastTrigger = null // 閉じたときにフォーカスを戻す起点

    function trapFocus(e) {
      if (e.key !== 'Tab' || !panel) return
      var focusable = panel.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')
      if (!focusable.length) return
      var first = focusable[0]
      var last = focusable[focusable.length - 1]
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus() }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus() }
      }
    }

    function open() {
      modal.removeAttribute('hidden')
      document.documentElement.classList.add('rsv-modal-open')
      vm.open()
      document.addEventListener('keydown', trapFocus)
      // モーダル内の最初のフォーカス可能要素にフォーカス
      setTimeout(function () {
        var first = panel && panel.querySelector('button:not([disabled]),a[href]')
        if (first) first.focus()
      }, 100)
    }
    function close() {
      modal.setAttribute('hidden', '')
      document.documentElement.classList.remove('rsv-modal-open')
      document.removeEventListener('keydown', trapFocus)
      // 閉じたら開いたトリガーへフォーカスを戻す（キーボード操作の連続性を保つ）
      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus()
      }
    }

    triggers.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault()
        lastTrigger = b
        // both 設定時: ボタンの data-reservation-flow で開く動線を指定（開く前に切替）
        var flow = b.getAttribute('data-reservation-flow')
        if (flow && vm && typeof vm.setFlowOrder === 'function') {
          vm.setFlowOrder(flow)
        }
        open()
      })
    })
    modal.querySelectorAll('[data-reservation-close]').forEach(function (b) {
      b.addEventListener('click', close)
    })
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close()
    })
    document.addEventListener('dispatch:reservation:cart_added', close)
    document.addEventListener('dispatch:reservation:close', close)
  }

  // ---- SP固定フッターCTA（ある程度スクロールしたら表示） --------------------
  function initFixedCta() {
    var fixed = document.querySelector('[data-reservation-fixed-cta]')
    if (!fixed) return
    // ビューポート高の約半分スクロールしたら表示（最初は出さない）
    function threshold() {
      return Math.max(300, (window.innerHeight || 600) * 0.5)
    }
    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0
      if (y > threshold()) {
        fixed.removeAttribute('hidden')
        fixed.setAttribute('aria-hidden', 'false')
      } else {
        fixed.setAttribute('hidden', '')
        fixed.setAttribute('aria-hidden', 'true')
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    onScroll()
  }

  // ---- template (Vue) ------------------------------------------------------
  // ユーザー向け文言はすべて t('key','fallback') 経由で locales キーを参照する
  // （値は snippet が window.RESERVATION_I18N に注入。未注入時は fallback の日本語を表示）。
  function TEMPLATE() {
    return [
      '<div class="rsv-app">',

      // ---------- STEP 'plan' (plan_first=プラン選択STEP1 / calendar_first=プラン選択STEP2) ----------
      '<section v-if="stepKey===\'plan\'" class="rsv-screen">',
      '  <div class="rsv-topbar"><div class="rsv-tl"><button v-if="step>1" class="rsv-back" @click="goBack" :aria-label="t(\'back\',\'戻る\')">←</button><span class="rsv-step">{{ t(\'step\'+step,\'STEP \'+step+\' / \'+stepCount) }}</span></div><h1>{{ flowOrder===\'calendar_first\' ? t(\'cf_choose_plan_title\',\'プランを選ぶ\') : bookingTitle }}</h1><div class="rsv-tr"><button class="rsv-close" @click="requestClose" :aria-label="t(\'close\',\'閉じる\')">✕</button></div></div>',
      '  <div class="rsv-scroll">',
      // plan_first: 店舗/プラン見出し（従来どおり）
      '    <div class="rsv-locbar" v-if="flowOrder===\'plan_first\' && ((boot.plan && boot.plan.title) || (boot.store && (boot.store.label || boot.store.image)))">',
      '      <div class="rsv-lph" v-if="boot.store && boot.store.image" :style="{backgroundImage:\'url(\'+boot.store.image+\')\'}"></div>',
      '      <div><div class="rsv-ln">{{ (boot.plan && boot.plan.title) || (boot.store && boot.store.label) }}</div><div class="rsv-la"><template v-if="boot.plan && boot.plan.title">{{ boot.store && boot.store.label }}<template v-if="boot.store && boot.store.sublabel"> ・ {{ boot.store.sublabel }}</template></template><template v-else>{{ boot.store && boot.store.sublabel }}</template></div></div>',
      '    </div>',
      // calendar_first: 選択日時の見出し＋「変更」で日時選び直し
      '    <div class="rsv-locbar" v-else-if="flowOrder===\'calendar_first\' && selected"><div><div class="rsv-ln">{{ selectedSlotLabel }}</div><div class="rsv-la">{{ boot.store ? boot.store.label : \'\' }}</div></div><button class="rsv-edit" @click="reselectDatetime">{{ t(\'change\',\'変更\') }}</button></div>',
      // calendar_first: 候補0件 → 選び直し導線（前進抑止）
      '    <div v-if="flowOrder===\'calendar_first\' && selected && slotPlanCandidates.length===0" class="rsv-emptyweek">{{ t(\'cf_no_plans_for_slot\',\'この日時で選べるプランがありません。\') }}<button class="rsv-link" @click="reselectDatetime">{{ t(\'cf_reselect_datetime\',\'日時を選び直す\') }}</button></div>',
      // プラン/人数ピッカー（calendar_first で候補0件のときは非表示）
      '    <template v-if="!(flowOrder===\'calendar_first\' && slotPlanCandidates.length===0)">',
      '    <div class="rsv-sec-h"><div class="rsv-h">{{ flowOrder===\'calendar_first\' ? t(\'cf_plans_for_slot\',\'この日時で選べるプラン\') : t(\'choose_plan\',\'プランを選ぶ\') }}</div></div>',
      '    <div class="rsv-plans">',
      '      <button v-for="pt in planTypeChoices" :key="pt" class="rsv-plan-card" :class="{sel: pt===planType}" @click="selectPlanType(pt)">',
      '        <span class="rsv-pc-name">{{ pt }}</span>',
      '        <span class="rsv-pc-radio"></span>',
      '      </button>',
      '    </div>',
      '    <template v-for="axis in extraAxesView" :key="axis.index">',
      '      <div class="rsv-sec-h" v-if="axis.values.length"><div class="rsv-h">{{ axis.name }}</div></div>',
      '      <div class="rsv-axis-chips" v-if="axis.values.length">',
      '        <button v-for="val in axis.values" :key="val" class="rsv-chip" :class="{sel: getExtra(axis.index)===val}" @click="setExtra(axis.index, val)">{{ val }}</button>',
      '      </div>',
      '    </template>',
      '    <div class="rsv-sec-h" v-if="peopleMax>peopleMin"><div class="rsv-h">{{ t(\'people_label\',\'利用人数\') }}</div></div>',
      '    <div class="rsv-people" v-if="peopleMax>peopleMin">',
      '      <button class="rsv-pbtn" @click="changePeople(-1)" :disabled="people<=peopleFloor">−</button>',
      '      <div class="rsv-pnum">{{ people }}<small>{{ t(\'people_unit\',\'名\') }}</small></div>',
      '      <button class="rsv-pbtn" @click="changePeople(1)" :disabled="people>=peopleCeil">＋</button>',
      '      <div class="rsv-pmax">{{ t(\'people_max_prefix\',\'最大\') }} {{ peopleCeil }}{{ t(\'people_unit\',\'名\') }}</div>',
      '    </div>',
      '    </template>',
      '    <div style="height:14px"></div>',
      '  </div>',
      '  <div class="rsv-dock">',
      '    <div class="rsv-summ"><span class="rsv-lbl">{{ t(\'plan_fee\',\'プラン料金\') }}</span><span class="rsv-price">{{ money(planPrice) }}{{ priceSuffix }}<small v-if="hasPeopleAxis">/ {{ people }}{{ t(\'people_unit\',\'名\') }}</small></span></div>',
      // plan_first: 空室カレンダーへ
      '    <button v-if="flowOrder===\'plan_first\'" class="rsv-btn rsv-btn-primary" :disabled="!planVariant" @click="goToCalendar">{{ t(\'see_calendar\',\'空室カレンダーを見る\') }}</button>',
      // calendar_first: 確定スロット再検証 → オプションへ
      '    <button v-else class="rsv-btn rsv-btn-primary" :disabled="!planVariant || revalidating || slotPlanCandidates.length===0" @click="proceedFromPlan">{{ revalidating ? t(\'cf_revalidating\',\'空き状況を確認中…\') : t(\'cf_to_options\',\'オプションへ進む\') }}</button>',
      '    <div v-if="flowOrder===\'plan_first\' && !planVariant" class="rsv-inline-note">{{ t(\'plan_not_found\',\'選択した組み合わせのプランが見つかりません。\') }}</div>',
      '    <div v-if="planError" class="rsv-inline-note">{{ planError }}</div>',
      '  </div>',
      '</section>',

      // ---------- STEP 2 (plan_first=日時カレンダー) ----------
      '<section v-if="stepKey===\'calendar\'" class="rsv-screen">',
      '  <div class="rsv-topbar"><div class="rsv-tl"><button v-if="step>1" class="rsv-back" @click="goBack" :aria-label="t(\'back\',\'戻る\')">←</button><span class="rsv-step">{{ t(\'step\'+step,\'STEP \'+step+\' / \'+stepCount) }}</span></div><h1>{{ t(\'choose_datetime\',\'日時を選ぶ\') }}</h1><div class="rsv-tr"><button class="rsv-close" @click="requestClose" :aria-label="t(\'close\',\'閉じる\')">✕</button></div></div>',
      '  <div class="rsv-scroll">',
      // plan_first: 確定済みプラン＋人数を表示し「変更」でプラン選択へ戻る
      '    <div class="rsv-locbar" v-if="flowOrder===\'plan_first\'"><div><div class="rsv-ln">{{ planLabel }}</div><div class="rsv-la">{{ boot.store ? boot.store.label : \'\' }}<template v-if="hasPeopleAxis"> ・ {{ people }}{{ t(\'people_unit\',\'名\') }}</template></div></div><button class="rsv-edit" @click="leaveCalendar">{{ t(\'change\',\'変更\') }}</button></div>',
      // calendar_first STEP1: プラン未確定のため店舗情報のみ（変更導線なし）
      '    <div class="rsv-locbar" v-else-if="boot.store && (boot.store.label || boot.store.image)"><div><div class="rsv-ln">{{ boot.store.label }}</div><div class="rsv-la" v-if="boot.store.sublabel">{{ boot.store.sublabel }}</div></div></div>',
      '    <div class="rsv-weeknav">',
      '      <button class="rsv-arr" @click="prevWeek" :disabled="atMinWeek" :aria-label="t(\'prev_week\',\'前の週\')">‹</button>',
      '      <div class="rsv-wlabel">{{ weekLabel }}</div>',
      '      <button class="rsv-arr" @click="nextWeek" :aria-label="t(\'next_week_aria\',\'次の週\')">›</button>',
      '    </div>',
      '    <div v-if="loadingWeek" class="rsv-loading">{{ t(\'loading\',\'読み込み中…\') }}</div>',
      '    <div v-else-if="weekError" class="rsv-error"><p>{{ weekError }}</p><button class="rsv-btn rsv-btn-ghost" @click="loadCurrentWeek">{{ t(\'retry\',\'再試行\') }}</button></div>',
      '    <template v-else-if="grid">',
      '      <div class="rsv-grid">',
      '        <div class="rsv-ghead">',
      '          <div></div>',
      '          <div v-for="h in grid.header" :key="h.iso" class="rsv-gd" :class="{sat:h.wd===6, sun:h.wd===0, today:h.isToday}">',
      '            <div class="rsv-wd">{{ WD[h.wd] }}</div><div class="rsv-dt">{{ h.date.getDate() }}</div>',
      "            <div class=\"rsv-lvl\" :class=\"'lvl-'+ (h.level==='◎'?'high':h.level==='○'?'mid':h.level==='△'?'low':'none')\">{{ h.level }}</div>",
      '          </div>',
      '        </div>',
      '        <div v-for="row in grid.rows" :key="row.slotStart" class="rsv-grow">',
      '          <div class="rsv-gtime">{{ row.slotStart }}</div>',
      '          <div v-for="c in row.cells" :key="c.iso" class="rsv-cell" :class="{open:c.selectable, none:c.state===\'-\', closed:c.state===\'closed\'}" @click="selectCell(c)">',
      '            <span v-if="c.state===\'○\'">○</span><span v-else-if="c.state===\'closed\'">×</span><span v-else>−</span>',
      '          </div>',
      '        </div>',
      '      </div>',
      '      <div v-if="!hasAnyOpen" class="rsv-emptyweek">{{ t(\'no_week\',\'この週は空きがありません。\') }}<button class="rsv-link" @click="nextWeek">{{ t(\'next_week\',\'翌週を見る ›\') }}</button></div>',
      '      <div class="rsv-helpbox">',
      '        <div class="rsv-help-h">{{ t(\'avail_about\',\'空き状況について\') }}</div>',
      '        <div class="rsv-legend">',
      '          <span class="rsv-lg"><b class="lvl-high">◎</b> {{ t(\'legend_high\',\'空きあり\') }}</span>',
      '          <span class="rsv-lg"><b class="lvl-mid">○</b> {{ t(\'legend_mid\',\'残りあり\') }}</span>',
      '          <span class="rsv-lg"><b class="lvl-low">△</b> {{ t(\'legend_low\',\'残り僅か\') }}</span>',
      '          <span class="rsv-lg"><b class="lvl-none">−</b> {{ t(\'legend_none\',\'受付不可\') }}</span>',
      '          <span class="rsv-lg"><b class="lvl-none">×</b> {{ t(\'legend_closed\',\'終日受付不可\') }}</span>',
      '        </div>',
      '      </div>',
      '    </template>',
      '    <div style="height:18px"></div>',
      '  </div>',
      '</section>',

      // ---------- STEP 3 (options・両フロー共有) ----------
      '<section v-if="stepKey===\'options\'" class="rsv-screen">',
      '  <div class="rsv-topbar"><div class="rsv-tl"><button v-if="step>1" class="rsv-back" @click="goBack" :aria-label="t(\'back\',\'戻る\')">←</button><span class="rsv-step">{{ t(\'step\'+step,\'STEP \'+step+\' / \'+stepCount) }}</span></div><h1>{{ t(\'choose_options\',\'オプションを選ぶ\') }}</h1><div class="rsv-tr"><button class="rsv-close" @click="requestClose" :aria-label="t(\'close\',\'閉じる\')">✕</button></div></div>',
      '  <div class="rsv-scroll">',
      '    <div class="rsv-locbar" v-if="selectedView">',
      '      <div><div class="rsv-ln">{{ selectedView.dateLabel }}<span :class="{weekend:selectedView.weekend}">（{{ selectedView.wd }}）</span> {{ selectedView.start }}〜{{ selectedView.end }}</div>',
      '      <div class="rsv-la">{{ planLabel }}<template v-if="hasPeopleAxis"> ・ {{ people }}{{ t(\'people_unit\',\'名\') }}</template></div></div>',
      '      <button class="rsv-edit" @click="backTo(2)">{{ t(\'change\',\'変更\') }}</button>',
      '    </div>',
      '    <div class="rsv-opt-intro"><div class="rsv-h">{{ t(\'add_options_h\',\'オプションの追加\') }}</div><div class="rsv-sub">{{ t(\'add_options_sub\',\'追加オプションをお選びいただけます。\') }}</div></div>',
      '    <div v-for="g in groups" :key="g.category" class="rsv-opt-sec">',
      '      <div class="rsv-osh" v-if="g.category !== \'other\' || g.required"><span v-if="g.category !== \'other\'">{{ g.category }}</span><span v-if="g.required" class="rsv-req">{{ t(\'required\',\'必須\') }}</span></div>',
      '      <div class="rsv-opt-list">',
      '        <div v-for="p in g.items" :key="p.productId" class="rsv-opt-row">',
      '          <div class="rsv-opt-main">',
      '            <div class="rsv-opt-thumb"><img v-if="isUrl(p.icon)" :src="p.icon" :alt="p.title" style="width:22px;height:22px;object-fit:contain"><span v-else v-html="sanitizeIcon(p.icon)"></span></div>',
      '            <div class="rsv-opt-info"><div class="rsv-on">{{ p.title }}</div><div class="rsv-op">{{ money(p.variants[0] ? p.variants[0].price : 0) }}<span v-if="isMultiVariant(p)">〜</span></div></div>',
      '            <template v-if="!isMultiVariant(p)">',
      '              <div v-if="variantQty(p, p.variants[0]) > 0" class="rsv-stepper">',
      '                <template v-if="maxForVariant(p, p.variants[0]) > 1">',
      '                  <button class="rsv-sb" @click="setVariantQty(p, p.variants[0], -1)">−</button>',
      '                  <span class="rsv-sv">{{ variantQty(p, p.variants[0]) }}</span>',
      '                  <button class="rsv-sb" @click="setVariantQty(p, p.variants[0], 1)" :disabled="variantQty(p, p.variants[0]) >= maxForVariant(p, p.variants[0])">＋</button>',
      '                </template>',
      '                <button v-else class="rsv-remove" @click="setVariantQty(p, p.variants[0], -1)">{{ t(\'remove\',\'削除\') }}</button>',
      '              </div>',
      '              <button v-else class="rsv-add" :disabled="!p.variants[0] || !p.variants[0].available" @click="setVariantQty(p, p.variants[0], 1)">{{ p.variants[0] && p.variants[0].available ? t(\'add\',\'追加\') : t(\'soldout\',\'在庫なし\') }}</button>',
      '            </template>',
      "            <button v-else class=\"rsv-add\" @click=\"toggleExpand(p)\">{{ expanded[p.productId] ? t('collapse','閉じる ▴') : (productQty(p) > 0 ? productQty(p) + t('count_unit_arrow','点 ▾') : t('select','選ぶ ▾')) }}</button>",
      '          </div>',
      '          <div v-if="isMultiVariant(p) && expanded[p.productId]" class="rsv-variants">',
      '            <div v-for="v in p.variants" :key="v.variantId" class="rsv-variant-row" :class="{disabled:!v.available}">',
      '              <span class="rsv-vlabel">{{ v.label }}</span>',
      '              <span class="rsv-vprice">{{ money(v.price) }}</span>',
      '              <div v-if="v.available" class="rsv-stepper">',
      '                <button class="rsv-sb" @click="setVariantQty(p, v, -1)" :disabled="variantQty(p, v) <= 0">−</button>',
      '                <span class="rsv-sv">{{ variantQty(p, v) }}</span>',
      '                <button class="rsv-sb" @click="setVariantQty(p, v, 1)" :disabled="variantQty(p, v) >= maxForVariant(p, v)">＋</button>',
      '              </div>',
      '              <span v-else class="rsv-soldout">{{ t(\'soldout\',\'在庫なし\') }}</span>',
      '            </div>',
      '          </div>',
      '        </div>',
      '      </div>',
      '    </div>',
      '    <div style="height:16px"></div>',
      '  </div>',
      '  <div class="rsv-dock">',
      '    <div class="rsv-summ"><span class="rsv-lbl">{{ t(\'total_tax_incl\',\'合計（税込）\') }}<span class="rsv-bd">{{ optionsCount>0 ? \'・ \'+t(\'options\',\'オプション\')+optionsCount+t(\'count_unit\',\'点\')+\' \'+money(optionsSubtotal) : \'・ \'+t(\'no_options_short\',\'オプションなし\') }}</span></span><span class="rsv-price">{{ money(total) }}{{ priceSuffix }}</span></div>',
      '    <div v-if="missingRequired.length" class="rsv-inline-note">{{ t(\'required_prefix\',\'必須カテゴリ（\') }}{{ missingRequired.join(\'、\') }}{{ t(\'required_suffix\',\'）を選択してください。\') }}</div>',
      '    <button class="rsv-btn rsv-btn-primary" :disabled="missingRequired.length>0" @click="goToConfirm">{{ t(\'to_confirm\',\'予約内容を確認する\') }}</button>',
      '  </div>',
      '</section>',

      // ---------- STEP 4 (confirm・両フロー共有) ----------
      '<section v-if="stepKey===\'confirm\'" class="rsv-screen">',
      '  <div class="rsv-topbar"><div class="rsv-tl"><button v-if="step>1" class="rsv-back" @click="goBack" :aria-label="t(\'back\',\'戻る\')">←</button><span class="rsv-step">{{ t(\'step\'+step,\'STEP \'+step+\' / \'+stepCount) }}</span></div><h1>{{ t(\'confirm_title\',\'予約内容の確認\') }}</h1><div class="rsv-tr"><button class="rsv-close" @click="requestClose" :aria-label="t(\'close\',\'閉じる\')">✕</button></div></div>',
      '  <div class="rsv-scroll">',
      '    <div class="rsv-recap" v-if="selectedView">',
      '      <div class="rsv-row"><div class="k">{{ t(\'label_datetime\',\'日時\') }}</div><div class="v"><b>{{ selectedView.dateLabel }}（{{ selectedView.wd }}） {{ selectedView.start }}</b> 〜 {{ selectedView.end }}</div></div>',
      '      <div class="rsv-row"><div class="k">{{ t(\'label_plan\',\'プラン\') }}</div><div class="v">{{ planLabel }}</div></div>',
      '      <div class="rsv-row" v-if="hasPeopleAxis"><div class="k">{{ t(\'label_people\',\'人数\') }}</div><div class="v">{{ people }}{{ t(\'people_unit\',\'名\') }}</div></div>',
      '    </div>',
      '    <div class="rsv-recap">',
      '      <div class="rsv-sub-h">{{ t(\'options\',\'オプション\') }}</div>',
      '      <template v-if="optionsCount>0">',
      '        <div v-for="(line, i) in optionLines" :key="i" class="rsv-opt-line">',
      '          <span class="ql">{{ line.label }}<small>×{{ line.qty }}</small></span>',
      '          <span class="qv">{{ money(line.lineTotal) }}</span>',
      '        </div>',
      '      </template>',
      '      <div v-else class="rsv-opt-none">{{ t(\'no_options\',\'追加オプションはありません\') }}</div>',
      '    </div>',
      '    <div class="rsv-recap rsv-recap-bare">',
      '      <div class="rsv-opt-line bare"><span class="ql muted">{{ t(\'plan_fee\',\'プラン料金\') }}<template v-if="hasPeopleAxis">（{{ people }}{{ t(\'people_unit\',\'名\') }}）</template></span><span class="qv">{{ money(planPrice) }}{{ priceSuffix }}</span></div>',
      '      <div v-if="optionsSubtotal>0" class="rsv-opt-line bare"><span class="ql muted">{{ t(\'options_subtotal\',\'オプション小計\') }}</span><span class="qv">{{ money(optionsSubtotal) }}</span></div>',
      '    </div>',
      '    <div class="rsv-total"><span class="t-lbl">{{ t(\'total_tax_incl\',\'合計（税込）\') }}</span><span class="t-val">{{ money(total) }}{{ priceSuffix }}</span></div>',
      '    <div class="rsv-notice"><span class="ic">!</span><span class="tx"><b>{{ boot.notice.title }}</b><br>{{ boot.notice.body }}</span></div>',
      '    <div v-if="submitError" class="rsv-error-box">{{ submitError }}</div>',
      '    <div style="height:8px"></div>',
      '  </div>',
      '  <div class="rsv-dock">',
      '    <button class="rsv-btn rsv-btn-primary" :disabled="submitting" @click="confirm">{{ submitting ? t(\'processing\',\'処理中…\') : t(\'do_reserve\',\'この内容で予約する\') }}</button>',
      '    <button class="rsv-btn rsv-btn-ghost" @click="backTo(3)">{{ t(\'edit_options\',\'オプションを編集\') }}</button>',
      '  </div>',
      '</section>',

      '</div>',
    ].join('\n')
  }

  function start() {
    // アセットが二重読込された場合でも初期化（イベント登録）を1回に限定する。
    if (window.__rsvV3Started) return
    window.__rsvV3Started = true
    boot() // Vue マウント＋モーダル制御（ログイン必須時は早期 return）
    initFixedCta() // SP固定フッターCTA（モーダル有無に関わらず）
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start)
  } else {
    start()
  }
})()
